import { getFeeds, getKeyForStorage, getRecommendations } from '~/actions/feed';
import {
  KEY_FEED_SESSION_STORAGE,
  KEY_FOR_ANY_FEED_EVENT_SESSION_STORAGE,
} from '~/actions/feed/constants';
import {
  addBasket,
  addPayment,
} from '~/actions/feed/utils/feedLocaleStorageControl';
import RestServices from '~/api';
import { getFromSessionStorage, saveToSessionStorage } from '~/helpers/storage';

/**
 * Обработчик клиентского события addToBasket
 * Если по переданному продукту ранее был клик из ленты, отправляет данные
 * @param productId
 * @param productCount
 */
export const feedAddToBasket = (
  productId: string,
  productCount: number = 1
) => {
  const { feedId, recType } = addBasket(productId);
  if (feedId) {
    RestServices.feedEvent.set({
      '@type': 'FeedAddToBasketEvent',
      productId,
      'quantity': productCount,
      feedId,
    });
  }

  return {
    feedId,
    recType,
  };
};

/**
 * Обработчик клиентского события addToPayment
 * Если по переданному продукту ранее было добавление в корзину, отправляет данные
 * @param items
 */
export const feedAddToPayment = (
  items: FeedOrderPaymentItem[]
): { items: FeedOrderPaymentItem[] } => {
  const processedItem = items.map((item) => {
    const { feedId, recType } = addPayment(item?.productId);
    if (feedId) {
      RestServices.feedEvent.set({
        '@type': 'FeedOrderPaymentEvent',
        'items': [item],
        feedId,
      });
    }
    item.feedId = feedId;
    item.recType = recType;

    return item;
  });

  return {
    items: processedItem,
  };
};

/**
 * Проверяет наличие списка лент в сессии
 * @returns
 */
const hasFeedListInSession = (): boolean =>
  getFromSessionStorage(KEY_FEED_SESSION_STORAGE, 'feedList') ? true : false;

/**
 * Обновляет или отображает ленту по внешнему ключу
 * @param feeds
 * @param externalKey
 * @param productsIdList
 */
const updateOrStartFeedByExternalKey = (
  feeds: Feed[],
  externalKey: string,
  productsIdList: string[]
  ): void => {
  const feedForRefresh = feeds.find(feed => feed.externalKey === externalKey);
  if (feedForRefresh) {
    getRecommendations(feedForRefresh);
  }
};

/**
 * Запрашивает список лент
 * @param externalKey
 * @param productsIdList
 */
const fetchFeeds = (externalKey: string, productsIdList: string[]) => {
  RestServices.feedList.get('ACTIVE').then((result: IFeedList) => {
    saveToSessionStorage(KEY_FEED_SESSION_STORAGE, 'feedList', result);
    if (result.payload.length > 0) {
      updateOrStartFeedByExternalKey(
        result.payload,
        externalKey,
        productsIdList
      );
    }
  });
};

/**
 * Обработчик клиентского события setProductsInBasket и setProductsInPages
 * Записывает массив productId в sessionStorage
 * Обновляет ленту, если она уже есть на странице
 * @param items
 */
export const feedSetSomeId = (
  items: FeedOrderPaymentItem[],
  externalKey: string = null,
  updateFeed: boolean = true,
  recommendationGenerationType: RecommendationGenerationType
) => {
  const someIdList = items.map(item => item.productId);
  const key = externalKey
    ? externalKey
    : KEY_FOR_ANY_FEED_EVENT_SESSION_STORAGE;
  saveToSessionStorage(getKeyForStorage(recommendationGenerationType), key, {
    url: window.location.href,
    someIdList,
  });
  if (updateFeed) {
    hasFeedListInSession()
      ? updateOrStartFeedByExternalKey(getFeeds(), externalKey, someIdList)
      : fetchFeeds(externalKey, someIdList);
  }
};
